<div class="text-center">
  <!-- Subheader -->
  <div class="mt-30 mb-15 headline-base">{{ "verification_2fa_toggle_sms_modal_subheader" | translate }}</div>
  <!-- Subtext -->
  @if (profile$ | async; as profile) {
    <div class="mt-30 mb-15 text-medium-black font-size-15">
      {{ "verification_2fa_toggle_sms_modal_subtext" | translate: [getUserPhone(profile)] }}
    </div>
  }
  <!-- N Digit Input -->
  <div class="mb-50 mt-50">
    <form class="mb-10">
      <div class="form-group inline-block">
        @for (digit of codeLength_; track digit) {
          <input
            [(ngModel)]="inputValues[digit]"
            [id]="'id_' + digit"
            [name]="'name_' + digit"
            class="code-input-field"
            type="number"
            (paste)="onPaste($event)"
            (keydown)="isNumberKey($event)"
            (keyup)="keytab($event, digit)" />
        }
      </div>
    </form>
  </div>
  <!-- Resend PIN -->
  <div class="mb-10 pt-30">
    <button (click)="resendPin()" class="resend-button">{{ "debit_card_order_pin_resend" | translate }}</button>
  </div>
</div>
